import {
  IconMapMetroMsk16,
  IconMapMetroSpb16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroNN16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ColoredIconWrapper } from '../../../../common/components/ColoredIconWrapper';
import { EUndergroundType } from '../../../../types/newbuildingHeader';

interface IUndergroundIconProps {
  lineColor: string;
  type: EUndergroundType;
}

const getIconByType = (type: EUndergroundType): React.ReactNode => {
  switch (type) {
    case EUndergroundType.Mow:
      return <IconMapMetroMsk16 />;
    case EUndergroundType.Spb:
      return <IconMapMetroSpb16 />;
    case EUndergroundType.Ekb:
      return <IconMapMetroEkb16 />;
    case EUndergroundType.Kzn:
      return <IconMapMetroKzn16 />;
    case EUndergroundType.Nsk:
      return <IconMapMetroNovosib16 />;
    case EUndergroundType.Smr:
      return <IconMapMetroSam16 />;
    case EUndergroundType.NN: // Нижний Новгород
      return <IconMapMetroNN16 />;
    default:
      return <IconMapMetroMsk16 />;
  }
};

export const UndergroundIcon: React.FC<IUndergroundIconProps> = ({ lineColor, type }) => {
  const color = React.useMemo(() => `#${lineColor}`, [lineColor]);
  const icon: React.ReactNode = React.useMemo(() => getIconByType(type), [type]);

  return <ColoredIconWrapper color={color}>{icon}</ColoredIconWrapper>;
};
